<div class="bg-th-blue mt-0 container-fluid">
    <div class=" d-flex justify-content-between align-content-center h-35">
        <div class="d-flex align-items-center" routerLink="/">
            <i class="fa fa-arrow-left text-white my-auto pointer"></i>
        </div>
        <a class="text-white f18 my-auto dirI d-flex align-items-center"> نظارت تصویری - دوربین‌ها </a>
    </div>
</div>

<main style="direction: rtl;" class="">

    <section [formGroup]="mdl_Request" class="row gx-0 gy-0 p-2">

        <!-- خودرو‌ها -->
        <div class="col-xxl-3 col-md-4 col-12 p-1">

            <div class="w-100 h-100 border border-2 p-2">

                <!-- دوربین های درحال استریم -->
                <div class="p-2 stream-container mb-2 w-100">
                    <div role="group" class="btn-group w-100">
                        <div class="w-100 row gx-0 gy-0">
                            <div class="col-6 p-1">
                                <input type="radio" name="tiType" id="all" [checked]="!isLiveStreaming"
                                    (click)="getAllCar(false)" class="btn-check w-100">
                                <label for="all" class="btn btn-outline-secondary w-100"> همه </label>
                            </div>
                            <div class="col-6 p-1">
                                <input type="radio" name="tiType" id="live" class="btn-check w-100"
                                    [checked]="isLiveStreaming" (click)="getAllCar(true)">
                                <label for="live" class="btn btn-outline-success w-100"> فعال‌ها </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- فیلتر جستجو -->
                <div class="search-container w-100">

                    <p class="mb-2 pe-2"> تعداد کل :

                        <strong> {{ lst_Car.length.toLocaleString() | faNum }} خودرو‌ </strong>

                    </p>

                    <input type="text" class="form-control" placeholder="جستجو کنید ..."
                        (keyup)="filter_list($event.target)">

                    <select class="form-select p-2 mt-2" formControlName="tiStatus"
                        (change)="onCameraStatus($event.target.value)">

                        <option value="-1"> فرامین گروهی </option>

                        <ng-container *ngIf="!isLiveStreaming">

                            <option value="0"> روشن کردن همه </option>

                            <option value="3"> خاموش کردن همه </option>

                            <option value="1"> روشن کردن دوربین‌های وقایع </option>

                            <option value="2"> روشن کردن دوربین‌های کابین </option>

                        </ng-container>

                        <ng-container *ngIf="isLiveStreaming">

                            <option class="" value="3"> خاموش کردن کردن همه </option>

                            <option class="" value="4"> خاموش کردن دوربین‌های وقایع </option>

                            <option class="" value="5"> خاموش کردن دوربین‌های کابین </option>

                        </ng-container>

                    </select>

                </div>

                <!-- لیست خودرو‌ها -->
                <div class="cars-container w-100 border-top p-1 mt-2">
                    <ng-container *ngFor="let item of lst_Car; let i = index">
                        <div class="row gx-0 gy-0 border-bottom border-dark mb-3" [style.backgroundColor]="getColor(item)">
                            <!-- اطلاعات خودرو -->
                            <div class="col-12 d-flex flex-column justify-content-center pe-2" (click)="openCar(item)">
                                <div class="d-flex justify-content-between pt-3">
                                    <p class="mb-0 fw-bold"> {{ item.strFullName | faNum }} </p>
                                    <ng-container *ngIf="isItemWaiting(item)">
                                        <div class="spinner-border spinner-sm text-secondary" role="status"
                                            aria-label="Loading">
                                            <span class="visually-hidden">در حال بارگذاری...</span>
                                        </div>
                                    </ng-container>
                                </div>
                                <p class="mb-0 text-muted text-end" (click)="updateTime($event,item,i)">
                                    <small>
                                        {{ item.strTime | faNum }} - {{ item.strDate | faNum }}
                                    </small>
                                </p>
                            </div>
                            <!-- چک باکس دوربین -->
                            <div class="col-12 border mt-1">

                                <div class="row gx-0 gy-0 py-1">

                                    <!-- دوربین وقایع -->

                                    <div class="col-6" style="border-left: 1px solid #dee2e6;">
                                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">
                                            <input class="form-check-input m-0" type="checkbox"
                                                [id]="item.strUnitID + 'front' " [checked]="isChecked(item,0)"
                                                (change)="selectRadio(item,'front')">
                                            <label class="form-check-label pointer text-muted me-2"
                                                [for]="item.strUnitID + 'front' ">
                                                <small> دوربین وقایع </small>
                                            </label>
                                        </div>
                                    </div>

                                    <!-- دوربین کابین -->

                                    <div class="col-6">
                                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">
                                            <input class="form-check-input m-0" type="checkbox"
                                                [id]="item.strUnitID + 'inside' " [checked]="isChecked(item,1)"
                                                (change)="selectRadio(item,'inside')">
                                            <label class="form-check-label pointer text-muted me-2"
                                                [for]="item.strUnitID + 'inside' ">
                                                <small> دوربین کابین </small>
                                            </label>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </ng-container>
                </div>

            </div>

        </div>

        <!-- دوربین ها -->
        <div class="col-xxl-9 col-md-8 col-12 p-1">
            <div class="w-100 h-100 border border-2">
                <div class="options-container row gx-0 gy-0 border-bottom p-1" aria-label="Template options">
                    <div class="col-7"></div>
                    <div class="col-5 p-1 d-flex justify-content-end align-items-center" aria-label="Template actions">
                        <button *ngFor="let item of templateActions" type="button"
                            class="btn border border-dark py-1 px-2 mx-1" (click)="item.action()"
                            [attr.aria-label]="item.label">
                            <i [class]="'fa ' + item.icon"></i>
                        </button>
                    </div>
                </div>
                <div id="cctvContainer" class="grid-container row gx-0 gy-0">
                    <ng-container *ngFor="let i of repeat(iTemplateView); let idx = index">
                        <div [ngClass]="getColClass(iTemplateView)" class="p-1"
                            [style.max-height]="'calc(87vh / ' + getRowDiv(iTemplateView) + ')'">
                            <div class="w-100 h-100">
                                <ng-container *ngIf="shouldShowThumb(idx)">
                                    <img src="../../../assets/Img/video-thumb.png" [alt]="'دوربین' + (idx + 1)">
                                </ng-container>
                                <ng-container *ngIf="checkedCameras[idx]?.strUnitId">
                                    <ng-container *ngIf="shouldShowVideo(idx)">
                                        <video-player 
                                            [tiChannel]="checkedCameras[idx].tiChannel"
                                            [src]="checkedCameras[idx].strUrl" 
                                            [obj_Cam]="checkedCameras[idx]">
                                        </video-player>
                                    </ng-container>

                                    <ng-container *ngIf="shouldShowStream(idx)">
                                        <stream-loader [obj_Camera]="checkedCameras[idx]"
                                            (updateChecked)="updateCheckedList($event)"
                                            (hideComponent)="failedRequest($event)">
                                        </stream-loader>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        
    </section>

</main>